import { Flex, Typography } from "antd";
import type { FC } from "react";

import { OrdersStatisticsChart } from "@src/components";

type HomePageProps = object;

export const HomePage: FC<HomePageProps> = () => {
    return (
        <Flex vertical gap={24} style={{ width: "100%" }}>
            <div>
                <Typography.Title level={2} style={{ margin: 0 }}>
                    Панель аналитики
                </Typography.Title>
                <Typography.Paragraph type="secondary" style={{ marginTop: 8 }}>
                    Отслеживайте ключевые показатели заказов и идентифицируйте тренды вовремя.
                </Typography.Paragraph>
            </div>

            <OrdersStatisticsChart />
        </Flex>
    );
};
